import Typography from 'components/generics/texts/Typography';
import classes from 'pages/residents/sign-lease/components/LeaseSummary/components/SignLeaseTerms/index.module.scss';
import useFetchContentByIds from '../../../../../../../hooks/requests/content/useFetchContentByIds';
import { LEASE_TERMS } from '../../../../../../../consts/idsContent';
import { useEffect, useState } from 'react';
import { ContentData } from '../../../../../../../types/content-types';

const SignLeaseTerms = () => {
  const [innerContent, setInnerContent] = useState<ContentData | undefined>(
    undefined
  );
  const { content } = useFetchContentByIds([LEASE_TERMS]);
  useEffect(() => {
    const res = content?.contents?.find(
      (item: any) => item.contentId === LEASE_TERMS
    );
    if (res) setInnerContent(res);
  }, [content]);
  return (
    <>
      {innerContent && (
        <div>
          <Typography
            variant="subtext"
            color="var(--color-concrete)"
            className={classes.terms}
          >
            <Typography className={classes.secParagraph}>
              {innerContent.subtitle || ''}
            </Typography>
            <Typography className={classes.secParagraph}>
              {innerContent.body || ''}
            </Typography>
          </Typography>
        </div>
      )}
    </>
  );
};

export default SignLeaseTerms;
